const u = (id) => `https://images.unsplash.com/${id}?q=80&w=1600&auto=format&fit=crop`;

export const IMG = {
  hero: u("photo-1782330300409-f6c1ae5f64cb"),
  gloves: u("photo-1639776738932-956082f0b704"),
  facility: u("photo-1720036237085-354bdcfb6a14"),
  ewaste: u("photo-1788025487883-c59e1f8edcaa"),
};

export const LOGOS = {
  ecologic: "/logos/ecologic.jpg",
  citeo: "/logos/citeo.jpg",
  corepile: "/logos/corepile.jpg",
};

export const PARTS = {
  motherboard: "/parts/motherboard.png",
  parts: "/parts/part1.jpg",
  cracked: "/parts/part2.jpg",
  cracked2: "/parts/part3.jpg",
  blocked: "/parts/part4.jpg",
  flex: "/parts/flex_used.png",
};

export const PROCESS = {
  inventaire: "/process/inventaire.png",
  offres: "/process/offres.png",
  logistique: "/process/logistique.png",
  controle: "/process/controle.png",
  paiement: "/process/paiement.png",
  recyclage: "/process/recyclage.png",
};
